import React from "react";
import { Platform, StyleSheet } from "react-native";
import { FAB, MD3Theme, useTheme } from "react-native-paper";
import PropTypes from "prop-types";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const ScrollFAB = ({ ScrollViewRef }) => {
  const theme = useTheme();
  const styles = styleGen(theme);

  const insets = useSafeAreaInsets();

  return <FAB
    icon="chevron-down"
    style={[styles.fab, { bottom: Platform.OS === "ios" ? 40 + insets.bottom : insets.bottom }]}
    color={theme.colors.primary}
    customSize={60}
    mode='elevated'
    onPress={() => ScrollViewRef.current.scrollToEnd({ animated: true })}
  />;
};

ScrollFAB.propTypes = {
  ScrollViewRef: PropTypes.shape({
    current: PropTypes.shape({
      scrollToEnd: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
};

const styleGen = (theme: MD3Theme) => StyleSheet.create({
  fab: {
    position: "absolute",
    borderRadius: 50,
    right: "5%",
    backgroundColor: theme.colors.background,
  },
});

export default ScrollFAB;